import { parseToRgb } from 'polished';

/**
 * Returns a usable rgb string that can be used within CSS for use in rgb or rgba
 */
// eslint-disable-next-line import/prefer-default-export
export const toRgbString = (hex: string): string => {
	try {
		const rgbObject = parseToRgb(hex);
		return [rgbObject.red, rgbObject.green, rgbObject.blue].join(',');
	} catch (err) {
		return '0,0,0';
	}
};
